// src/components/maps/ViewLocationMap.jsx
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
  Box,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MapIcon from "@mui/icons-material/Map";
import MapView from "./MapView"; // your existing MapView component
import {
  LocationOn as LocationOnIcon,
} from "@mui/icons-material";
import { motion } from "framer-motion";

const ViewLocationMap = ({ issue }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      {/* Trigger Button */}
      <Button
        variant="outlined"
        color="success"
        size="small"
        startIcon={<MapIcon />}
        onClick={handleOpen}
      >
        View Location
      </Button>

      {/* Popup Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="100%"
        height="auto"
        TransitionProps={{ timeout: 400 }}
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          <Typography
                variant="h6"
                fontWeight={700}
                gutterBottom
                color="success.main"
                display="flex"
                alignItems="center"
                gap={1}
              >
                <LocationOnIcon /> Location Map
              </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            ❌
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 0 }}>
           <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >              

              <Box
                sx={{
                  borderRadius: 3,
                  overflow: "hidden",
                  border: "1px solid #e0e0e0",
                  position: "relative",
                }}
              >
                <Box sx={{ height: 320, width: "100%" }}>
                  <MapView coordinates={[issue]} />
                </Box>
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 12,
                    right: 12,
                  }}
                >
                  
                </Box>
              </Box>
            </motion.div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ViewLocationMap;
